// WarningCard.jsx
import React from 'react';
import { Card, TextBox, StyledAlertIcon, IconContainer, ContentWrapper } from './styles';

export const WarningCard = () => {
  return (
    <Card>
      <ContentWrapper>
        <IconContainer>
          <StyledAlertIcon />
        </IconContainer>
        <TextBox>
          Para criar o contrato, é necessário concluir todos os documentos obrigatórios:
          <br />
          • <strong>Ambiental → Gerenciar Projeto → tópico "PRÉ-ANÁLISE DE VIABILIDADE"</strong>: 6 documentos;
          <br />
          • <strong>Comercial</strong>: 1 documento;
          <br />
          • <strong>Jurídico</strong>: 2 documentos.
        </TextBox>
      </ContentWrapper>
    </Card>
  );
};